const CONFIRMATION_CONTEXT_KEY = "onground:public-payment-confirmation:v1";
const CONFIRMATION_CONTEXT_MAX_AGE_MS = 24 * 60 * 60 * 1000;

const clean = (value, max = 300) =>
  String(value == null ? "" : value).trim().slice(0, max);

const normalizeGateway = (value) => {
  const gateway = clean(value, 20).toUpperCase();
  return ["RAZORPAY", "ESEWA"].includes(gateway) ? gateway : "";
};

const isValidToken = (value) => /^[a-f0-9]{48}$/i.test(clean(value, 80));

export const savePublicPaymentConfirmationContext = (storage, value = {}) => {
  if (!storage) return false;

  const slug = clean(value.slug, 160);
  const reservationId = clean(value.reservationId, 80);
  const confirmationToken = clean(value.confirmationToken, 80);
  const paymentGateway = normalizeGateway(value.paymentGateway);

  if (!slug || !reservationId || !isValidToken(confirmationToken) || !paymentGateway) {
    return false;
  }

  try {
    storage.setItem(
      CONFIRMATION_CONTEXT_KEY,
      JSON.stringify({
        slug,
        reservationId,
        confirmationToken,
        paymentGateway,
        createdAt: Date.now(),
      }),
    );
    return true;
  } catch {
    return false;
  }
};

export const getPublicPaymentConfirmationContext = (storage) => {
  if (!storage) return null;

  try {
    const raw = storage.getItem(CONFIRMATION_CONTEXT_KEY);
    if (!raw) return null;

    const value = JSON.parse(raw);
    const slug = clean(value?.slug, 160);
    const reservationId = clean(value?.reservationId, 80);
    const confirmationToken = clean(value?.confirmationToken, 80);
    const paymentGateway = normalizeGateway(value?.paymentGateway);
    const createdAt = Number(value?.createdAt || 0);

    const expired =
      !Number.isFinite(createdAt) ||
      createdAt <= 0 ||
      Date.now() - createdAt > CONFIRMATION_CONTEXT_MAX_AGE_MS;

    if (
      !slug ||
      !reservationId ||
      !isValidToken(confirmationToken) ||
      !paymentGateway ||
      expired
    ) {
      storage.removeItem(CONFIRMATION_CONTEXT_KEY);
      return null;
    }

    return {
      slug,
      reservationId,
      confirmationToken,
      paymentGateway,
      createdAt,
    };
  } catch {
    try {
      storage.removeItem(CONFIRMATION_CONTEXT_KEY);
    } catch {}
    return null;
  }
};

export const clearPublicPaymentConfirmationContext = (storage) => {
  if (!storage) return false;
  try {
    storage.removeItem(CONFIRMATION_CONTEXT_KEY);
    return true;
  } catch {
    return false;
  }
};
